import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CreateUser, UpdateUser, User, UserLogActivity, UserLogActivityQuery } from 'store/user/types';

interface InitialState {
  isLoading: boolean;
  isCreateUserLoading: boolean;
  isUpdatedUserLoading: boolean;
  entities: User[] | null;
  error: any;
  isActivityLogsLoading: boolean;
  activityLogs: UserLogActivity[] | null;
  activityLogsError: any;
  actions: string[] | null;
  isActivityLogsActionsLoading: boolean;
  isActivityLogsModulesLoading: boolean;
  modules: string[] | null;
}

const initialState: InitialState = {
  isLoading: false,
  isUpdatedUserLoading: false,
  isCreateUserLoading: false,
  entities: null,
  error: null,
  isActivityLogsLoading: false,
  activityLogs: null,
  activityLogsError: null,
  actions: null,
  isActivityLogsActionsLoading: false,
  isActivityLogsModulesLoading: false,
  modules: null,
};

const users = createSlice({
  name: 'users',
  initialState,
  reducers: {
    requestUsers: (state): void => {
      state.isLoading = true;
    },
    requestUpdateUser: (state, { payload }: PayloadAction<UpdateUser>) => {
      state.isUpdatedUserLoading = true;
    },
    requestCreateUser: (state, { payload }: PayloadAction<CreateUser>) => {
      state.isCreateUserLoading = true;
    },
    getUsersSuccess: (state, { payload }: PayloadAction<User[]>): void => {
      state.isLoading = false;
      state.isCreateUserLoading = false;
      state.isUpdatedUserLoading = false;
      state.entities = payload;
    },
    getUsersError: (state, { payload }: PayloadAction<string>): void => {
      state.isLoading = false;
      state.isUpdatedUserLoading = false;
      state.error = payload;
    },
    getUserLogActivity: (state, { payload }: PayloadAction<UserLogActivityQuery>): void => {
      state.isActivityLogsLoading = true;
    },
    getUserLogActivitySuccess: (state, { payload }: PayloadAction<UserLogActivity[]>): void => {
      state.isActivityLogsLoading = false;
      state.activityLogs = payload;
    },
    getUserLogActivityError: (state, { payload }: PayloadAction<string>): void => {
      state.isActivityLogsLoading = false;
      state.activityLogsError = payload;
    },
    clearUserLogActivity: (state) => {
      state.activityLogs = null;
    },
    getNewUserError: (state, { payload }: PayloadAction<string>): void => {
      state.isLoading = false;
      state.error = payload;
    },
    getUserLogActivityExport: (state, { payload }: PayloadAction<UserLogActivityQuery>): void => {
      // state.isActivityLogsLoading = true;
    },
    requestUsersExport: (): void => {},
    getUserLogActivityModules: (state, { payload }: PayloadAction<any>): void => {
      state.isActivityLogsModulesLoading = true;
    },
    getUserLogActivityActions: (state, { payload }: PayloadAction<any>): void => {
      state.isActivityLogsActionsLoading = true;
    },
    getUserLogActivityActionsSuccess: (state, { payload }: PayloadAction<string[]>): void => {
      state.isActivityLogsLoading = false;
      state.actions = payload;
    },
    getUserLogActivityActionsError: (state, { payload }: PayloadAction<string>): void => {
      state.isActivityLogsLoading = false;
    },
    getUserLogModulesSuccess: (state, { payload }: PayloadAction<string[]>): void => {
      state.isActivityLogsModulesLoading = false;
      state.modules = payload;
    },
    getUserLogModulesError: (state, { payload }: PayloadAction<string>): void => {
      state.isActivityLogsModulesLoading = false;
    },
  },
});

export const {
  requestUsers,
  requestUpdateUser,
  requestCreateUser,
  getUsersSuccess,
  getUsersError,
  getNewUserError,
  getUserLogActivity,
  getUserLogActivitySuccess,
  getUserLogActivityError,
  clearUserLogActivity,
  getUserLogActivityExport,
  requestUsersExport,
  getUserLogActivityActions,
  getUserLogActivityActionsSuccess,
  getUserLogActivityActionsError,
  getUserLogActivityModules,
  getUserLogModulesSuccess,
  getUserLogModulesError,
} = users.actions;

export default users.reducer;
